const theatreSelector = '[data-seal-product-step-theatre]';
const stepSelector = '[data-seal-product-step-button]';
const mediaSelector = '[data-seal-product-step-media]';
const panelSelector = '[data-seal-product-step-panel]';

function activateStep(theatre, button, { centerStep = true } = {}) {
  const target = button.dataset.sealProductStepButton;
  const stepButtons = Array.from(theatre.querySelectorAll(stepSelector));
  const mediaItems = Array.from(theatre.querySelectorAll(mediaSelector));
  const panelItems = Array.from(theatre.querySelectorAll(panelSelector));

  stepButtons.forEach((item) => {
    const active = item === button;
    item.classList.toggle('is-active', active);
    item.setAttribute('aria-selected', String(active));
    item.tabIndex = active ? 0 : -1;
  });

  mediaItems.forEach((item) => {
    item.classList.toggle('is-active', item.dataset.sealProductStepMedia === target);
  });

  panelItems.forEach((item) => {
    const active = item.dataset.sealProductStepPanel === target;
    item.classList.toggle('is-active', active);
    item.hidden = !active;
  });

  const steps = button.closest('.seal-product-step-theatre__steps');
  if (centerStep && steps?.scrollWidth > steps.clientWidth) {
    button.scrollIntoView({ block: 'nearest', inline: 'center' });
  }
}

function focusStep(stepButtons, currentIndex, direction) {
  const nextIndex = (currentIndex + direction + stepButtons.length) % stepButtons.length;
  const nextButton = stepButtons[nextIndex];

  nextButton.focus({ preventScroll: true });
  activateStep(nextButton.closest(theatreSelector), nextButton);
}

function initProductStepTheatre(theatre) {
  if (!theatre || theatre.dataset.sealProductStepTheatreReady === 'true') return;
  theatre.dataset.sealProductStepTheatreReady = 'true';

  const stepButtons = Array.from(theatre.querySelectorAll(stepSelector));
  if (!stepButtons.length) return;

  stepButtons.forEach((button, index) => {
    button.tabIndex = button.classList.contains('is-active') ? 0 : -1;
    button.addEventListener('click', () => activateStep(theatre, button));
    button.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowRight' && event.key !== 'ArrowUp' && event.key !== 'ArrowLeft') {
        return;
      }

      event.preventDefault();
      const direction = event.key === 'ArrowDown' || event.key === 'ArrowRight' ? 1 : -1;
      focusStep(stepButtons, index, direction);
    });
  });

  activateStep(theatre, stepButtons.find((button) => button.classList.contains('is-active')) || stepButtons[0], {
    centerStep: false,
  });
}

function initAllProductStepTheatres() {
  document.querySelectorAll(theatreSelector).forEach(initProductStepTheatre);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllProductStepTheatres);
} else {
  initAllProductStepTheatres();
}

document.addEventListener('shopify:section:load', (event) => {
  event.target?.querySelectorAll?.(theatreSelector).forEach((theatre) => {
    theatre.dataset.sealProductStepTheatreReady = 'false';
    initProductStepTheatre(theatre);
  });
});
